import React from 'react';
import Header from '@/components/layout/Header';
import SubconsProtectedRoute from '@/components/layout/SubconsProtectedRoute';
import { OptimizedSubconsManagement } from '@/components/subcons/OptimizedSubconsManagement';

/**
 * Subcons Page
 * ✅ Phase 4: Protected with SubconsProtectedRoute
 * ✅ Non-Regression: Defense in depth for direct URL access
 */
export default function Subcons() {
  return (
    <SubconsProtectedRoute>
      <div className="min-h-screen bg-background">
        <Header />
        <main className="container mx-auto py-6">
          <OptimizedSubconsManagement />
        </main>
      </div>
    </SubconsProtectedRoute>
  );
}